import {
  Button,
  SuitabilityBadge,
  TableBody,
  Text,
  Tooltip,
  HStack,
  VStack,
} from '@genial/components';
import React from 'react';

import { TableItemProps } from '../models';

import { CustomerBlockStatus } from './components/CustomerBlockStatus';
import { IconCustomerList } from './components/IconCustomerList';

const TabletTableItemBase = ({ customerCaption, handleSelectCustomer, item }: TableItemProps) => {
  return (
    <TableBody testId={`table-customer-body-${item.cpfCnpjFormatted}`} height={120}>
      <VStack p="inline.xxs" space="inline.xxxs" flex={1}>
        <HStack alignItems={'center'} justifyContent={'space-between'}>
          <Text variant={'semibold'} fontSize="md" color="neutral.darkest">
            {item.name}
          </Text>
          <HStack alignItems={'center'} space="inline.nano">
            {customerCaption.length > 0 && <IconCustomerList icons={customerCaption} />}
            <Tooltip testID="qa" label={item.suitabilityProfileName || ''}>
              <SuitabilityBadge label={item.suitabilityProfileName} hideText />
            </Tooltip>
          </HStack>
        </HStack>
        <HStack alignItems={'center'} space="inline.nano" justifyContent={'space-between'}>
          <VStack>
            <Text variant="regular" fontSize="xs" color="neutral.medium">
              CPF/CNPJ
            </Text>
            <Text variant="regular" fontSize="md" color="neutral.darkest">
              {item.cpfCnpjFormatted}
            </Text>
          </VStack>
          <VStack>
            <Text variant="regular" fontSize="xs" color="neutral.medium">
              Cadastro
            </Text>
            <Text variant="regular" fontSize="md" color="neutral.darkest">
              <CustomerBlockStatus customer={item} />
            </Text>
          </VStack>
          <VStack>
            <Text variant="regular" fontSize="xs" color="neutral.medium">
              Conta de Custódia
            </Text>
            <Text variant="regular" fontSize="md" color="neutral.darkest">
              {item.custodyAccountNumber}
            </Text>
          </VStack>
          <VStack>
            <Text variant="regular" fontSize="xs" color="neutral.medium">
              Saldo disponível
            </Text>
            <Text variant="regular" fontSize="md" color="neutral.darkest">
              {item.availableBalance}
            </Text>
          </VStack>
          <Button
            testID="table-customer-button-select-customer"
            onPress={handleSelectCustomer}
            isDisabled={item.registrationBlocked}>
            {item.buttonSelectCustomer}
          </Button>
        </HStack>
      </VStack>
    </TableBody>
  );
};

export const TabletTableItem = React.memo(TabletTableItemBase);
